var _feGaussianBlur, _linearGradient, _radialGradient, _path, _radialGradient2, _path2, _linearGradient2, _circle;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgActionPreview(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    height: 1.204,
    y: -0.102,
    width: 1.266,
    x: -0.133,
    id: "b",
    style: {
      colorInterpolationFilters: "sRGB"
    }
  }, _feGaussianBlur || (_feGaussianBlur = /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.721
  })))), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ebebeb",
      fillOpacity: 1
    },
    fill: "#50e6ff",
    d: "M39 16v25a2 2 0 0 1-2 2H11a2 2 0 0 1-2-2V7a2 2 0 0 1 2-2h17l11 11z"
  }), _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 28.529,
    x2: 33.6,
    y1: 15.472,
    y2: 10.4,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3079d6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#297cd2"
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ccc",
      fillOpacity: 1
    },
    fill: "url(#a)",
    d: "M28 5v9a2 2 0 0 0 2 2h9L28 5z"
  }), _radialGradient || (_radialGradient = /*#__PURE__*/React.createElement("radialGradient", {
    id: "c",
    cx: 36.108,
    cy: 36.04,
    r: 10.085,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.354,
    stopColor: "#006185"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.538,
    stopColor: "#1a8dad"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.826,
    stopColor: "#41cde8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.962,
    stopColor: "#50e6ff"
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a8a8a8",
      fillOpacity: 0.48235294,
      filter: "url(#b)"
    },
    fill: "url(#c)",
    d: "M36 26c-5.523 0-10 4.477-10 10a9.962 9.962 0 0 0 2.864 7H37a2 2 0 0 0 2-2V26.459A10.011 10.011 0 0 0 36 26z"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#199be2",
    d: "m43.992 42.224-1.768 1.768 3.935 3.935a.25.25 0 0 0 .354 0l1.414-1.414a.25.25 0 0 0 0-.354l-3.935-3.935z"
  })), _radialGradient2 || (_radialGradient2 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "d",
    cx: 36.012,
    cy: 36.048,
    r: 9.802,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.693,
    stopColor: "#006185"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.921,
    stopColor: "#35c1f1"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#d)",
    d: "M41.8 40.033 40.033 41.8l2.191 2.192 1.768-1.768z"
  })), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "e",
    x1: 30.455,
    x2: 41.669,
    y1: 30.455,
    y2: 41.669,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#a3ffff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.223,
    stopColor: "#9dfbff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#8bf1ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.885,
    stopColor: "#6ee0ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#63daff"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 36,
    cy: 36,
    r: 8,
    fill: "url(#e)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActionPreview);
export default __webpack_public_path__ + "static/media/actionPreview.8ea810d01f291f6f466125fea73efde1.svg";
export { ForwardRef as ReactComponent };